import { render, staticRenderFns } from "./AutoLoadContainer.vue?vue&type=template&id=c5b2388a&"
import script from "./AutoLoadContainer.vue?vue&type=script&lang=ts&"
export * from "./AutoLoadContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports